// Analytics tracking helper for newx-site
// Usage in Stimulus controllers:
// import { track } from "~/analytics"
// track('event_name', { property: 'value' })

/**
 * Track a custom event using window.analytics
 * @param {string} eventName - The name of the event to track
 * @param {Object} properties - Optional properties to attach to the event
 */
export function track(eventName, properties = {}) {
  if (typeof window.analytics?.track === 'function') {
    window.analytics.track(eventName, {
      ...properties,
      timestamp: new Date().toISOString(),
      url: window.location.href,
      path: window.location.pathname
    })
  }
}

/**
 * Track a page view event
 * @param {string} pageName - Optional page name for the view
 */
export function trackPageView(pageName = null) {
  track('pageview', {
    page: pageName || window.location.pathname
  })
}
